import { useState } from "react";
import { WorkspaceKey } from "../model/workspace.types";
import { WorkspaceStoreInterface } from "../model/workspace.types";
import { UserInterface } from "@/shared/model/api.types";
import { DepartmentInterface } from "@/shared/model/api.types";

export const useWorkspaceStore = (): WorkspaceStoreInterface => {
  const [loading, setLoadingState] = useState<Record<WorkspaceKey, boolean>>({
    users: false,
    departments: false,
  });
 
  const [error, setErrorState] = useState<Record<WorkspaceKey, string | null>>({
    users: null,
    departments: null,
  });

  const setLoading = (key: WorkspaceKey, v: boolean) => {
    setLoadingState(prev => ({ ...prev, [key]: v }));
  };

  const setError = (key: WorkspaceKey, e: string | null) => {
    setErrorState(prev => ({ ...prev, [key]: e }));
  };

  const [departments, setDepartments] = useState<DepartmentInterface[]>([]);
  const [myDepartments, setMyDepartments] = useState<DepartmentInterface[]>([]);
  const [users, setUsers] = useState<UserInterface[]>([]);
  const [subDepartments, setSubDepartments] = useState<DepartmentInterface[]>([]);
  const [subGenDepartments, setSubGenDepartments] = useState<DepartmentInterface[]>([]);
  

  return {
    loading, setLoading,
    error, setError,
    users, setUsers,
    departments, setDepartments,
    myDepartments, setMyDepartments,
    subDepartments, setSubDepartments,
    subGenDepartments, setSubGenDepartments
  };
};